export default [
    {
        path: '/sales/customer-category',
        name: 'customer-category',
        props: true,
        component: () => import('@/views/sales/customer-category/index.vue'),
        meta: {
            pageTitle: 'Customer Category',
            breadcrumb: [
                {
                text: 'Customer Category',
                active: true,
                },
            ],
        },
    },
    {
        path: '/sales/customer-category/add',
        name: 'create-customer-category',
        component: () => import('@/views/sales/customer-category/create.vue'),
        meta: {
            pageTitle: 'Create Customer Category',
            breadcrumb: [
                {
                text: 'Customer Category',
                to: { name: 'customer-category' },
                },
                {
                text: 'Create Customer Category',
                active: true,
                },
            ],
        },
    },
    {
        path: '/sales/customer-category/:id',
        name: 'detail-customer-category',
        props: true,
        component: () => import('@/views/sales/customer-category/detail.vue'),
        meta: {
            pageTitle: 'Detail Customer Category',
            breadcrumb: [
                {
                text: 'Customer Category',
                to: { name: 'customer-category' },
                },
                {
                text: 'Detail Customer Category',
                active: true,
                },
            ],
        },
    },
]